import { Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useWidgetContext } from '../Widget';

export default function WidgetHelperText() {
  const { widget, chartType } = useWidgetContext();
  // Use the translation files to get the right text with the widget id.
  const helperText = widget?.display?.helpText ?? '';
  const isKpi = chartType === 'kpi';

  // Check if the translation exists, if not return null.
  if (!helperText?.length) {
    return null;
  }

  return (
    <Tooltip
      data-testid={`widget-helper-text--${widget?.id}`}
      title={helperText}
      placement="top"
      sx={{
        alignSelf: isKpi ? 'start' : 'center',
      }}
    >
      <HelpOutlineIcon
        data-testid={`widget-helper-text-icon--${widget?.id}`}
        fontSize="small"
        sx={(theme) => {
          const isLight = theme.palette.mode === 'light';
          return {
            alignSelf: isKpi ? 'start' : 'center',
            color: isLight ? theme.blox.colors.bluegray : theme.blox.colors.white,
          };
        }}
      />
    </Tooltip>
  );
}
